import { DomainSerializer } from 'src/app/global/serializables/domain.serializer';
import { ConciliacaoBancariaTev } from '../domain/conciliacao-bancaria-tev.model';

export class ConciliacaoBancariaTevSerializer extends DomainSerializer<ConciliacaoBancariaTev> {}
